import styled from 'styled-components'

interface MainContainerProps {
  isSnackbarAvailable: boolean
  hasCommonFooterUsed?: boolean
}
export const MainContainer = styled.div<MainContainerProps>`
  width: 100%;
  background: #090909;
  ${({isSnackbarAvailable, hasCommonFooterUsed}) =>
    // add height if new common footer is not used
    !hasCommonFooterUsed &&
    `
    height: ${
      isSnackbarAvailable ? 'calc(100vh - 6.5rem)' : 'calc(100vh - 3.5rem)'
    };
  `}
`
export const ActionContainer = styled.div`
  width: 100%;
  height: 3.5rem;
`
